/**
 * Created by stonewang on 2017/8/14.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Popover, Menu, Badge } from 'antd';
import './style.css';

class DmsTab extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      visible: false,
    }
    this.clickHandle = this.clickHandle.bind(this);
    this.changeHandle = this.changeHandle.bind(this);
  }
  clickHandle ({item, key, keyPath}) {
    this.setState({ visible: false });
    if(this.props.onChange && typeof  this.props.onChange === 'function') {
      this.props.onChange({ item, key, keyPath });
    }
  }
  changeHandle (visible) {
    this.setState({ visible })
  }

  render() {
    const { defaultKey, options, className, hasBadge } = this.props;
    const content = options.length>1 ? <Menu
      onClick={this.clickHandle}
      style={{margin: '-8px -16px'}}>
      {
        options.map((item, index) => <Menu.Item key={index}>{item}</Menu.Item>)
      }
    </Menu> : null;

    return <div className={className ? `dms-tab-bar ${className}` : "dms-tab-bar"}>
      {
        options.length>1 ? <Popover style={{marginTop: '3px'}}
                                    placement="bottom"
                                    title={null}
                                    visible={this.state.visible}
                                    content={content}
                                    onVisibleChange={this.changeHandle}
                                    trigger="click">
          <div className={options.length>1 ? "dms-tab-name v-line arrow-down" : "dms-tab-name v-line"}>
            {options[defaultKey]}
          </div>
        </Popover> : hasBadge ? <div className={options.length>1 ? "dms-tab-name v-line arrow-down" : "dms-tab-name v-line"}>
          <Badge count={hasBadge} className={'customBadge'}>{options[defaultKey]}</Badge>
        </div> : <div className={options.length>1 ? "dms-tab-name v-line arrow-down" : "dms-tab-name v-line"}>
          {options[defaultKey]}
        </div>
      }
      {
        this.props.children ? <div className="dms-tab-btn">
          {
            this.props.children
          }
        </div> : null
      }

    </div>
  }
};
DmsTab.propTypes = {
  defaultKey: PropTypes.number.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func,
};
export default DmsTab;


// WEBPACK FOOTER //
// ./src/components/dmsTab.js